import React from 'react'
// import './specials.scss'
import AutoMenu from '../../react/AutoMenu'
import {Link} from 'react-router-dom'
export default function () {
  return(
    <div className="catering-page">
      {/* <div className="top-banner" style={{backgroundImage: "url(http://www.lamariarestaurant.com/images/slideshow-22-940-400.jpg)"}}>
        <h1>Catering</h1>
      </div> */}

      <AutoMenu tagsToShow={['catering']} />

      <div className="full-menu-link-wrapper">
        <Link to="/order" className="button">Go to Full Menu</Link>
      </div>
    </div>
  )
}
